import styled from "styled-components";

export const HomeContainer = styled.div`
  min-height: 100vh;
  padding: 20px;
  background-color: ${({ theme }) => theme.colors.LIGHT_GRAY};
`;
